<div class="zwi-sermon">
  <div class="zwi-sermon__main">
    <div class="zwi-sermon__content">
      <img width="30px" [src]="sermon.ministry.profileImage" [alt]="sermon.ministry.name" class="zwi-sermon__avatar">
      <div class="zwi-sermon__label">
        <div class="zwi-sermon__line zwi-sermon__overline">
          <a [routerLink]="['/' + sermon?.ministry?.username]" (click)="goToMinistry($event)" class="zwi-sermon__line">{{ sermon?.ministry?.name }}</a>
          @if (sermon?.speaker?.name && sermon.speaker.name !== 'Anonymous') { <!-- This is a conditional statement -->
            <span class="zwi-list-delimeter">·</span>
            <span>{{ sermon?.speaker?.name }}</span>
          }
        </div>
        <div class="zwi-sermon__title">{{ sermon?.name }}</div>
        @if (hasReferences()) {
          <div class="zwi-sermon__line  zwi-sermon__caption">{{ getReferences(sermon?.references) }}</div>
        }
      </div>
      <div class="zwi-spacer"></div>
      @if (bookmarkable) {
        @if (sermon?.favorite) {
          <button (click)="unstar($event)" mat-icon-button>
            <mat-icon>bookmark</mat-icon>
          </button>
        } @else {
          <button (click)="star($event)" mat-icon-button>
            <mat-icon>bookmark_border</mat-icon>
          </button>
        }
      }
    </div>
    <div class="zwi-sermon__play" (click)="toggleSermon($event)">
      @if (playingSermon?.id === sermon.id && sermonStatus === 'PLAYING') {
        <mat-icon class="zwi-sermon__play-button">pause</mat-icon>
      } @else {
        <mat-icon class="zwi-sermon__play-button">play_arrow</mat-icon>
      }
      <div class="zwi-sermon__duration">{{ getDuration(sermon.duration) }}</div>
      <!--      <div class="zwi-sermon__duration">28 min</div>-->
    </div>
  </div>
</div>
<div class="zwi-card">

  <!--  <mat-list-item>-->
  <!--    <img matListItemAvatar width="30px" [src]="sermon.ministry.profileImage" [alt]="sermon.ministry.name">-->
  <!--    <span matListItemTitle>{{ sermon?.name }}</span>-->
  <!--    <span matListItemLine>{{ sermon?.speaker?.name }}</span>-->
  <!--    <span matListItemLine *ngIf="hasReferences()">{{ getReferences(sermon?.references) }}</span>-->
  <!--    <a matListItemLine [routerLink]="['/' + sermon?.ministry?.username]">{{ sermon?.ministry?.name }}</a>-->
<!--  </mat-list-item>-->
<!--    <img (click)="playSermon(sermon)" matListAvatar [src]="sermon.avatar">-->
<!--    <zwi-play-button [sermon]="sermon" mat-list-icon>play_arrow</zwi-play-button>-->
<!--    <img matListItemAvatar width="30px" [src]="sermon.ministry.profileImage" [alt]="sermon.ministry.name">-->
<!--    <span matListItemTitle>{{ sermon?.name }}</span>-->
<!--    <p matListItemLine>{{ sermon?.speaker?.name }}</p>-->
<!--    <p matListItemLine>{{ getReferences(sermon?.references) }}</p>-->
<!--    <a matListItemLine [routerLink]="['/' + sermon?.ministry?.username]">{{ sermon?.ministry?.name }}</a>-->
<!--    <button *ngIf="sermon?.favorite; else unfavorite" (click)="unstar()" mat-icon-button>-->
<!--      <mat-icon>star</mat-icon>-->
<!--    </button>-->
<!--    <ng-template #unfavorite>-->
<!--      <button (click)="star()" mat-icon-button>-->
<!--        <mat-icon>star_border</mat-icon>-->
<!--      </button>-->
<!--    </ng-template>-->

</div>


